import { toast as toastify } from "react-toastify";

export function toast(message: string) {
  toastify(message);
}
